<template>
  <div class="full-area">
    <header class="question-header" v-if="!data.fields.questionImage.fields.file.url">
      <h2>{{data.fields.questionTitle}}</h2>
    </header>

    <header class="question-header image-question" v-if="data.fields.questionImage.fields.file.url">
      <div
        class="img"
        :style="{'backgroundImage': `url(${data.fields.questionImage.fields.file.url})`}"
      ></div>
    </header>
    <content class="content delay-entry">
      <div class="grid-wrapper">
        <div
          :span="12"
          v-for="option in randomizedOptions"
          :key="option"
          class="binary-box trinary-box"
          :class="{'selected-box': form.selected === option}"
          @click="selectThis(option)"
        >
          <div
            class="center-me"
            :class="`card_thumbs-${option}`"
          >
            <i :class="`enlarge-icon em em-${option}`"></i>
          </div>
        </div>
      </div>
    </content>
    <footer>
      <SkipQuestionButton
        :location="'locate-bottom'"
        v-on:skip="selectThis('NS/NR')"
      ></SkipQuestionButton>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Emoji',

  props: [ 'data' ],

  components: {
    SkipQuestionButton: () => import('Components/base/SkipQuestionButton')
  },

  data () {
    return {
      options: [ 'heart', 'laughing', 'open_mouth', 'rage', 'cry', 'grinning' ],
      form: {
        question: this.data.fields.questionTitle,
        id: this.data.sys.id,
        selected: null,
        timeToCompletion: null,
        timestamps: {
          start: new Date(),
          finish: null,
          valid: null
        }
      }
    }
  },

  computed: {
    randomizedOptions () {
      const options = this.options
      return options.sort(function () { return 0.5 - Math.random() })
    }
  },

  methods: {
    selectThis (item) {
      this.form.selected = item
    },
    next () {
      this.form.timestamps.finish = new Date()
      this.$emit('next', this.form)
    },
    validInput (value) {
      // Add simple validation: if it exists, it is valid.
      if (value) {
        this.form.timestamps.valid = new Date()
        this.form.timeToCompletion = this.form.timestamps.valid.getTime() - this.form.timestamps.start.getTime()
        return true
      } else {
        return false
      }
    }
  },

  watch: {
    // Add a simple watch to trigger next automatically after some ms
    'form.selected': function (newVal, oldVal) {
      if (this.validInput(newVal)) {
        setTimeout(() => {
          this.next()
        }, 200)
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .content {
    margin-bottom: 60px;
  }

  .enlarge-icon {
    transform: scale(2);
  }

  .center-me {
    display: flex;
    flex: 1;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    justify-content: center;
    align-items: center;
    color: white;
    border-radius: 5px;
    font-size: 2.5em;
  }

  .card_thumbs-up {
    background: $color-emphasis-alt;
  }
  .card_thumbs-down {
    background: $color-emphasis;
  }

  .selected-box {
    animation: standOut 0.4s ease-in-out forwards;
  }
</style>
